export default "__VITE_PUBLIC_ASSET__cc991f7f__"